__turbopack_context__.v({
  "fadeIn": "bonus-bar-module-scss-module__SWI1la__fadeIn",
  "nbclub": "bonus-bar-module-scss-module__SWI1la__nbclub",
  "nbclub__bonusesCount": "bonus-bar-module-scss-module__SWI1la__nbclub__bonusesCount",
  "root": "bonus-bar-module-scss-module__SWI1la__root",
});
